import DownloadCSVButton, {
  DownloadCSVProps,
} from "@/reports/components/DownloadCSVButton";

import {
  overviewExplanationTextCss,
  overviewInfoContainer,
  overviewTitleContainerCss,
  overviewTitleCss,
} from "./ContainerHeaderSection.style";

export interface ContainerHeaderSectionProps {
  title?: string | undefined;
  explanationText?: string | undefined;
  downloadCSVProps?: DownloadCSVProps;
}

const ContainerHeaderSection = ({
  title,
  explanationText,
  downloadCSVProps,
}: ContainerHeaderSectionProps) => {
  return (
    <div css={overviewInfoContainer}>
      <div css={overviewTitleContainerCss}>
        <h2 css={overviewTitleCss}>{title}</h2>
        {downloadCSVProps ? <DownloadCSVButton {...downloadCSVProps} /> : null}
      </div>
      <div css={overviewExplanationTextCss}>{explanationText}</div>
    </div>
  );
};

export default ContainerHeaderSection;
